import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppBreadcrumbComponent } from './app-breadcrumb.component';

@Component({
  selector: 'app-page-shell',
  standalone: true,
  imports: [CommonModule, AppBreadcrumbComponent],
  template: `
    <div class="page-shell">
      <app-breadcrumb></app-breadcrumb>
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
    .page-shell {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      min-width: 0;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageShellComponent {}
